import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ChargebackErrorModal = ({ show, onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} size="m" title={t('Pedido con contracargo')} onClose={onClose}>
      <Styles.MainContainer>
        <Text type="bodyMRegular">
          {t(
            'Este pedido tiene un contracargo en curso o sin resolver, y por lo tanto la acción elegida no se puede procesar.'
          )}
        </Text>
        <Button fullWidth onClick={onClose}>
          {t('Entendido')}
        </Button>
      </Styles.MainContainer>
    </Modal>
  )
}

export default ChargebackErrorModal
